import axios from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleRedirectUrlCheck } from '../common/redirectUrlCheck';
import axiosClient from '../libs/axiosClient';
import { setToken, STORAGE_ITEMS } from './auth';
const KAKAO_REST_API_KEY = '3a0c0e9eeac0eb075503b3af32109fed';
const KAKAO_REDIRECT_URI = `${window.location.origin}/auth/kakao/callback`;
export const KAKAO_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?client_id=${KAKAO_REST_API_KEY}&redirect_uri=${KAKAO_REDIRECT_URI}&response_type=code`;
function Kakao() {
  const navigate = useNavigate();
  useEffect(() => {
    let params = new URL(document.URL).searchParams;
    let code = params.get('code');
    axiosClient
      .post(
        '/func/user/login/kakao',
        {
          code: code,
        },
        {
          headers: {
            'Access-Control-Allow-Origin': 'https://api.us.ondoc.co.kr',
          },
          withCredentials: true,
        },
      )
      .then((res) => {
        setToken(res.data);
        let rurl = localStorage.getItem('rurl');
        if (handleRedirectUrlCheck(rurl || '/')) navigate(rurl || '/');
        else navigate('/');
      })
      .catch((err) => {
        alert(err.response.data.detail);
        navigate('/login');
      });
  }, []);
  return <div></div>;
}
export default Kakao;
